import { Dictionary } from '@ngrx/entity';
import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { SharedApplicationState, ViewOptionsState } from '../shared-state.interface';
import { ViewOptions } from './view-options.entity';
import { viewOptionsAdapter } from './view-options.reducer';

export const getViewOptionsState: MemoizedSelector<
    object,
    ViewOptionsState,
    DefaultProjectorFn<ViewOptionsState>
> = createFeatureSelector<ViewOptionsState>('viewOptions');

const { selectAll, selectEntities } = viewOptionsAdapter.getSelectors(getViewOptionsState);

export const selectViewOptions: (state: SharedApplicationState) => ViewOptionsState = (state: SharedApplicationState) =>
    state.viewOptions;

export function getViewOptions(
    id: string
): MemoizedSelector<object, ViewOptions | undefined, DefaultProjectorFn<ViewOptions | undefined>> {
    return createSelector(selectEntities, (entries: Dictionary<ViewOptions>) => entries[id]);
}

export const viewOptionsSelector: MemoizedSelector<
    object,
    Dictionary<ViewOptions>,
    DefaultProjectorFn<Dictionary<ViewOptions>>
> = createSelector(selectEntities, (entries: Dictionary<ViewOptions>) => entries);
